import Client from '../HttpClient';

const baseUrl = '/gateway/wombat-mgt/api/vs/manage-guest-tag';

const tagList = (merchantId, branchId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/${branchId}/guest-tags`, data);
};

const addTag = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/guest-tags`, data);
};

const findTag = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/guest-tags/${id}`);
};

const updateTag = (merchantId, id, data) => {
	return Client.put(`${baseUrl}/${merchantId}/guest-tags/${id}`, data);
};

const delTag = (merchantId, id) => {
	return Client.del(`${baseUrl}/${merchantId}/guest-tags/${id}`);
};

export default {
	tagList,
	addTag,
	findTag,
	updateTag,
	delTag,
};
